
'use strict';

const Swiper = require('swiper/bundle').Swiper;

const initPopOver = require('../components/initPopOver');

function initSwiperSlider(slider) {
    if (!slider) {
        return;
    }

    let sliderConfig;
    try {
        sliderConfig = JSON.parse(slider.dataset.sliderConfig);
    } catch (e) {
        return;
    }

    const nextEl = slider.querySelector('.swiper-button-next');
    const prevEl = slider.querySelector('.swiper-button-prev');
    const sliderConfigDefault = {
        navigation: {
            nextEl,
            prevEl
        }
    };

    const sliderSwiperElement = slider.querySelector('.swiper');
    // eslint-disable-next-line no-new
    new Swiper(sliderSwiperElement, { ...sliderConfigDefault, ...sliderConfig });
}

function initSwiperSliderWhenInView(slider) {
    const observer = new IntersectionObserver((entries) => {
        if (entries[0]?.isIntersecting) {
            initSwiperSlider(slider);
            observer.unobserve(slider);
        }
    }, {
        rootMargin: '50%'
    });
    observer.observe(slider);
}

module.exports = function () {
    const globalSwiperSelector = '.js-global-swiper-slider';
    document.querySelectorAll(`${globalSwiperSelector}`).forEach((slider)=>{
        if (!slider.classList.contains('js-init-externally')) {
            initSwiperSliderWhenInView(slider);
        } else {
            slider.classList.add('js-init-attempted-and-skipped');
        }
    });

    document.addEventListener('swiper:external-init', (e) => {
        const slider = e.detail?.slider;
        if (slider) {
            const swiper = slider.querySelector('.swiper');
            if (!swiper.classList.contains('swiper-initialized')) {
                initSwiperSliderWhenInView(slider);
            }
        }
    });

    $(document).on('einstein:initSlider', function (e) {
        const { einsteinSliderId } = e.detail;
        if (einsteinSliderId) {
            const einsteinSlider = document.querySelector(`#cq_recomm_slot-${einsteinSliderId} .js-global-swiper-slider`);
            if (einsteinSlider) {
                // Remove out of stock products from the DOM
                einsteinSlider.querySelectorAll("[data-available='out-of-stock']").forEach((product)=> {
                    product.closest('.swiper-slide')?.remove();
                });

                initSwiperSlider(einsteinSlider);

                initPopOver();
                document.dispatchEvent(new CustomEvent('search:filtered'));
                document.body.dispatchEvent(new CustomEvent('product:tileRendered', { detail: einsteinSlider, bubbles: true }));
            }
        }
    });
};

module.exports.initSwiperSlider = initSwiperSlider;
